// extracted by mini-css-extract-plugin
export default {"gif":"G76957d"};